define(["jquery"], function ($) {
  "use strict";
  return function (options) {
    let _showButton = false;
    let _buttonShown = false;
    let _scrollAmount = 150; // in px
    let $_button = $('.footer__scroll-top');

    $(window).on('scroll', (e) => {
      _showButton = $('body').scrollTop > _scrollAmount || document.documentElement.scrollTop > _scrollAmount;
      if(_showButton != _buttonShown) {
        $_button.css({'display': (_showButton ? 'flex' : 'none')});
        _buttonShown = _showButton;
      }
    });

    $_button.on('click', () => {
      window.scrollTo(0, 0);
    });
  }
});
